import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    const permissions = route.data.permissions as Array<string>;

    const hasPermission = this.authService.hasPermission(...permissions);

    if (!hasPermission) {
      this.router.navigate(['/']);
    }

    return hasPermission;
  }
}
